import { render, staticRenderFns } from "./dicManage.vue?vue&type=template&id=e8bb658a&scoped=true"
import script from "./dicManage.vue?vue&type=script&lang=js"
export * from "./dicManage.vue?vue&type=script&lang=js"
import style0 from "./dicManage.vue?vue&type=style&index=0&id=e8bb658a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bb658a",
  null
  
)

export default component.exports